//components
import { Container } from '@/components/Grid/Container';

import {
  SectionWrapper,
  Title,
  ListContainer,
  AwardsWrapper,
  Year,
  Text,
} from './Awards.styles';

const awards = [
  {
    year: '2023',
    awards: (
      <ul>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://blog.foodshippers.org/2023-top-food-chain-technology-list-announced-by-fsas-food-chain-digest"
          >
            Food Shippers of America's 2023 "Top Food Chain Technology List".
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.blueprism.com/customers/awards/"
          >
            Best Newcomer Americas by our RPA vendor (SS&C Blue Prism).
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.logisticstransportationreview.com/loadsmart"
          >
            Logistics & Transportation Review Magazine - Top 10 Freight
            Brokerage Service Provider 2023.
          </a>
        </li>

        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.iso.io/blog/iso-awards/"
          >
            ISO Technologies 2022 Excellence in Service Award.
          </a>
        </li>
      </ul>
    ),
  },
  {
    year: '2022',
    awards: (
      <ul>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://blog.loadsmart.com/2022/11/16/loadsmart-ranked-number-214th-fastest-growing-company-in-north-america-on-the-2022-deloitte-technology-fast-500"
          >
            Deloitte Technology Fast 500 (#214).
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.youtube.com/watch?v=XHM_jeQebqE"
          >
            Illuminate 2022: Excellence in Engineering Operations.
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.freightwaves.com/news/freightwaves-names-2023-freighttech-100"
          >
            FreightWaves FreightTech 100.
          </a>
        </li>
        <li>Named No. 881 on the annual Inc. 5000 list.</li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.ey.com/en_us/news/2022/04/ey-announces-eoy-2022-midwest-finalists"
          >
            Entrepreneur of the Year Midwest Finalists (founders) - E&Y.
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.forbes.com/lists/americas-best-startup-employers/?sh=2fb4b27b2ad7"
          >
            Forbes 2022 America's Best Startup Employers.
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.freightwaves.com/news/freighttech-25"
          >
            2022 FreightTech 25 #16.
          </a>
        </li>
      </ul>
    ),
  },
  {
    year: '2021',
    awards: (
      <ul>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.ey.com/en_us/news/2021/06/ey-eoy-2021-midwest-finalists"
          >
            Entrepreneur of the Year Midwest Finalists (founders) - E&Y
          </a>
        </li>
      </ul>
    ),
  },
  {
    year: '2020',
    awards: (
      <ul>
        <li>Top 25 Companies Disrupting Freight - FreightWaves (#18).</li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://blog.foodshippers.org/2023-top-food-chain-technology-list-announced-by-fsas-food-chain-digest"
          >
            EY Entrepreneur Of The Year® 2020 New York Award Finalist.
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cbinsights.com/research/artificial-intelligence-top-startups-2020/"
          >
            Top AI 100: The Artificial Intelligence Startups - CB Insights.
          </a>
        </li>
      </ul>
    ),
  },
  {
    year: '2019',
    awards: (
      <ul>
        <li>Top 25 Companies Disrupting Freight - FreightWaves (#15).</li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.prnewswire.com/news-releases/loadsmarts-automated-freight-brokerage-system-awarded-company-of-the-year-by-frost--sullivan-300793548.html"
          >
            Automated On-Demand Freight Brokerage, Company of the Year - Frost
            and Sullivan.
          </a>
        </li>
      </ul>
    ),
  },
  {
    year: '2018',
    awards: (
      <ul>
        <li>Top 25 Companies Disrupting Freight - FreightWaves (#22).</li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://blog.loadsmart.com/2018/09/06/cb-insights-selects-loadsmart-as-startup-disrupting-the-supply-chain-logistics-industry"
          >
            125 Startups Disrupting the Supply Chain - CB Insights.
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.globenewswire.com/en/news-release/2018/09/10/1568811/0/en/Loadsmart-named-a-Cool-Vendor-by-Gartner-in-Cool-Vendors-Intelligent-Supply-Chain-Execution-Technologies-by-Gartner.html"
          >
            Cool Vendor in Intelligent Supply Chain Execution Technologies.
          </a>
        </li>
      </ul>
    ),
  },
  {
    year: '2017',
    awards: (
      <ul>
        <li>
          DOGA Award in Design and Architecture for Interaction Design (UX) -
          DOGA Oslo, Norway.
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://blog.loadsmart.com/2017/05/02/loadsmart-honored-by-aba-with-2017-stevie-award"
          >
            Most Innovative Tech Company of the Year - Stevie® Award.
          </a>
        </li>
      </ul>
    ),
  },
];

export const Awards = () => (
  <SectionWrapper>
    <Container>
      <Title>Awards and Recognition</Title>
    </Container>

    <Container>
      <ListContainer>
        {awards.map((item, key) => {
          const index = `board-${key}`;
          return (
            <AwardsWrapper key={index}>
              <Year>{item.year}</Year>
              <Text>{item.awards}</Text>
            </AwardsWrapper>
          );
        })}
      </ListContainer>
    </Container>
  </SectionWrapper>
);
